// this file was auto-generated by rake i18n:generate_js.
// you probably shouldn't edit it directly
import mergeI18nTranslations from 'mergeI18nTranslations';

// we use JSON.parse here instead of just loading it as a javascript object literal
// because according to https://v8.dev/blog/cost-of-javascript-2019#json that is faster
mergeI18nTranslations(JSON.parse("{\"de\":{\"CollectionView\":{\"no_items\":\"Keine Elemente\"}},\"hu\":{\"CollectionView\":{\"no_items\":\"Nincsenek elemek.\"}}}"));
